import { call, put } from 'redux-saga/effects';
import { filterOperationsByAppName, OperationAppName } from '@monorepo/shared-lib';
import {
  fetchAdvancedUserRightsFailure,
  fetchAdvancedUserRightsSuccess,
} from '../actions';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { FetchAdvancedUserRightsResponse, getAdvancedUserRights } from '../api';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { turnMessageOn } from 'store/app/actions';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchAdvancedUserRightsSaga() {
  try {
    let err: ApiError | null;
    const response: FetchAdvancedUserRightsResponse = yield call(
      getAdvancedUserRights
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(
      fetchAdvancedUserRightsSuccess(
        filterOperationsByAppName(
          response.data,
          OperationAppName.GENERATE_TAX,
        )
      )
    );
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchAdvancedUserRightsFailure());
  }
}
